import { WHY_POINTS, IMAGES } from "../data/content";
import { SectionHeader, CTABand } from "./Home";
import { TrustSeal } from "../components/TrustSeal";

export default function WhyChooseUsPage() {
  return (
    <div data-testid="why-choose-us-page">
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
          <img src={IMAGES.handshake} alt="Professional partnership" className="w-full h-[420px] object-cover order-2 lg:order-1" />
          <div className="order-1 lg:order-2">
            <SectionHeader
              eyebrow="Why Choose Us"
              title="Diligence is a craft. We've mastered it."
              sub="Anyone can pull a record. Reading it correctly — across decades of handwriting, legacy formats, and legal nuance — is where Terraa & Title stands apart."
            />
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32 bg-[#113835] tt-grain">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <SectionHeader dark eyebrow="Our Differentiators" title="Six reasons professionals choose us." className="mb-16" />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {WHY_POINTS.map((w) => (
              <div key={w.title} data-testid={`why-point-${w.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="bg-[#113835] p-10">
                <w.icon size={28} strokeWidth={1} className="text-[#C1A74A]" />
                <h3 className="font-heading text-base font-medium text-white mt-5">{w.title}</h3>
                <p className="mt-3 text-sm text-white/65 font-light leading-relaxed">{w.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <TrustSeal />

      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-left">
          <p className="tt-eyebrow mb-6">Operational Strengths</p>
          <div className="space-y-8">
            {[
              ["Dedicated case managers", "A single point of contact from intake to delivery, with proactive status updates."],
              ["Committed timelines", "Standard, priority, and urgent tracks with delivery dates we put in writing."],
              ["Secure handling", "Uploaded documents and findings are encrypted and access-restricted to your assigned team."],
              ["Audit-ready formats", "Reports designed for legal opinions, credit files, and board approvals without rework."],
            ].map(([t, d]) => (
              <div key={t} className="border-l-2 border-[#C1A74A] pl-8">
                <h3 className="font-heading text-lg font-medium text-[#113835]">{t}</h3>
                <p className="mt-2 text-sm text-gray-600 font-light leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
}
